<script setup>
import { computed } from 'vue';

import HeadingTitle from '@/components/layouts/HeadingTitle.ce.vue';
import TariffsTable from '@/components/layouts/TariffsTable.ce.vue';
import TariffsTableRowGroup from '@/components/layouts/TariffsTableRowGroup.ce.vue';
import TranslationValue from '@/components/layouts/TranslationValue.ce.vue';

import { regionalTariffs } from '@/tariffs/regional_tariffs';

const getRowGroups = computed(() => regionalTariffs.getRowGroups);
</script>

<template>
    <HeadingTitle>
        <TranslationValue id="page2_heading_living_tariff" />
    </HeadingTitle>

    <p class="mb-6">
        <TranslationValue id="page2_into" />
    </p>

    <TranslationValue id="page2_click_personalized_lt_phr" />

    <TariffsTable id="regional-tariffs">
        <template #thead>
            <th scope="col" class="px-6 py-3"></th>
            <th scope="col" class="px-6 py-3 text-center">
                <TranslationValue id="page2_lt_per_hour" />
            </th>
            <th scope="col" class="px-6 py-3 text-center">
                <TranslationValue id="page2_lt_per_year" />
            </th>
        </template>
        <template #tbody>
            <TariffsTableRowGroup :row-groups="getRowGroups()"/>
        </template>
    </TariffsTable>

    <p class="my-4">
        <TranslationValue id="page2_click_personalized_lt_phr" />
    </p>
</template>
